import React from 'react';
import { formatToThousands } from '../../utils/number';
import Tooltip from '../Tooltip';
import Icon from '../Icon/Icon';

if (process.browser) require('./PublicationStat.scss');

export default function PublicationStat({
  caption,
  tip,
  value,
  ...props,
}) {
  const displayValue = !Number.isInteger(value)
    ? 'N/A'
    : formatToThousands(parseInt(value, 10));

  return (
    <li className={`stat-box ${(tip ? 'with-tooltip' : '')}`} {...props}>
      { value === undefined
        ? <Icon spin className="stat-box-icon" />
        : <data className="number" value={value} data-name="value">{displayValue}</data>
      }
      <p className="caption" data-name="caption">
        { caption }
      </p>
      { tip && <Tooltip tip={tip} /> }
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationStat/PublicationStat.js